import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const QrCard = ({ url, compact = false, testid = "getapp-qr-card", title = "Scan with your phone", desc = "Point your camera at the code to open this page on Android or iPhone." }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Link copied"); setTimeout(() => setCopied(false), 1800); } catch { toast.error("Could not copy — long-press the link instead"); }
  };
  return (
    <div className={`rounded-3xl bg-white ring-1 ring-slate-200 shadow-[0_20px_50px_-24px_rgba(14,165,233,0.45)] ${compact ? "p-4" : "p-6"} flex items-center gap-5`} data-testid={testid}>
      <div className="shrink-0 rounded-2xl bg-white p-2 ring-1 ring-slate-100" data-testid={`${testid}-code`}>
        <QRCodeSVG value={url} size={compact ? 96 : 128} fgColor="#0F172A" level="M" />
      </div>
      <div className="min-w-0">
        <p className="font-display text-lg font-semibold text-slate-900">{title}</p>
        <p className="mt-1 text-sm text-slate-500">{desc}</p>
        <button onClick={copy} data-testid={`${testid}-copy`} className="mt-3 inline-flex items-center gap-1.5 max-w-full h-8 px-3 rounded-full bg-slate-100 text-xs font-medium text-slate-700 hover:bg-slate-200 transition-colors">
          {copied ? <Check size={13} className="text-emerald-600" /> : <Copy size={13} />}
          <span className="truncate font-mono">{url.replace(/^https?:\/\//, "")}</span>
        </button>
      </div>
    </div>
  );
};

export default QrCard;
